<template>
    <div class="good_box">
        <div class="text-center"
            style="position: fixed;width:100%;height:100px;top:40%;font-size:20px;margin-top:-100px;">
            キャンセル申請を受け付けました<br>
            またご都合が良いときに是非ご参加下さい。
        </div>
        <div style="position: fixed;top: 60%;width:100%;">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="d-grid gap-2" style="padding: 0 5px;">
                            <a type="button" class="btn btn-luna"
                                style="font-size:18px; padding:12px 0;border-color:#fff;"
                                href="/event/list">閉じる</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
    
<script>
export default {
    data() {
        return {
        };
    },
}
</script>